<template>
  <div class="cp">
    <div class="cp__title">購入内容の確認</div>
    <Attention v-if="error" :text="error"/>
    <div class="cp__item">
      <dl class="itemData">
        <dt class="itemData__name">{{ item.name }}</dt>
        <dt class="itemData__label">価格</dt>
        <dd class="itemData__data">￥{{ item.priceTaxin }}(税込)</dd>
        <dt class="itemData__label">お支払い方法</dt>
        <dd class="itemData__data">{{ payment.method }}</dd>
      </dl>
    </div>
    <form ref="form" :action="action" method="post" @submit.prevent>
      <input type="hidden" name="_token" :value="form.token">
      <input type="hidden" name="amazonCheckoutSessionId" :value="form.sessionId" />
      <input type="hidden" name="amzpPrefixCode" :value="form.amzp_prefix_code" />
      <input type="hidden" name="return" value="1">
      <input
        v-for="(value, name) in form.params"
        :key="name"
        type="hidden"
        :name="name"
        :value="value"
      />
      <div class="cp__foot">
        <submit-button
          type="button"
          text="修正"
          class="cp__modify"
          :disabled="lock"
          @click="cancel"
        />
        <submit-button
          v-if="!error"
          type="button"
          text="購入を確定"
          design="fill"
          class="cp__purchase"
          :disabled="lock"
          @click="submit"
        />
      </div>
    </form>
  </div>
</template>

<script>
import Attention from '@/utvStore/components/common/Attention'
import SubmitButton from "@/utvStore/components/partials/SubmitButton"

export default {
  name: 'ConfirmationPurchase',
  components:{
    Attention,
    SubmitButton,
  },
  props: {
    error: {
      type: String,
      default: '',
    },
    item: {
      type: Object,
      default() {
        return {}
      }
    },
    payment: {
      type: Object,
      default() {
        return {}
      },
    },
    form: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  data() {
    return {
      action: '',
      lock: false,
    }
  },
  methods: {
    cancel() {
      this.lock = true
      this.action = this.form.cancel
      this.$nextTick(() => {
        this.$refs.form.submit()
      })
    },
    submit() {
      this.lock = true
      this.action = this.form.checkout
      this.$nextTick(() => {
        this.$refs.form.submit()
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.cp {
  color: #32373F;
  padding: 47px 30px 107px;
  &__title {
    font-weight: bold;
    font-size: 21px;
    line-height: 31px;
    text-align: center;
    margin: 0 0 35px;
  }
  &__item {
    background: linear-gradient(86.53deg, #FFF3F5 21.4%, #F9F4FD 76.64%);
    box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.15);
    border-radius: 7px;
    padding: 2px 15px;
    margin: 0 0 38px;
  }
  &__foot {
    display: flex;
    justify-content: center;
    margin: 0 -4.5px;
  }
  &__modify,
  &__purchase {
    flex: 0 1 50%;
    margin: 0 4.5px;
    box-shadow: none !important;
  }
}
.itemData {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  line-height: 1.38;
  margin: 0;
  padding: 0;
  &__name,
  &__label,
  &__data {
    padding: 16px 0;
  }
  &__name {
    flex: 1 1 100%;
    font-size: 13px;
  }
  &__label {
    flex: 1 1 75px;
    font-size: 12px;
    font-weight: normal;
  }
  &__data {
    flex: 1 1 calc(100% - 75px);
    margin: 0;
    font-size: 14px;
    text-align: right;
    &::before {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      margin-top: -18px;
      height: 1px;
      background: linear-gradient(86.53deg, #FF7497 21.4%, #CB8BFF 76.64%);
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Payment/ConfirmationPurchase.vue